export function useTooltip(messager: string): boolean {
    if (!messager) return false
    if (typeof messager !== 'string') return false
    return messager.length > 0
}
